"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneMap = void 0;
const services_1 = require("./services");
class OneMap {
    constructor(options) {
        this.options = options;
        this.auth = new services_1.Auth(this);
        this.search = new services_1.Search(this);
        this.common = new services_1.Common(this);
        this.convert = new services_1.Convert(this);
        this.theme = new services_1.Theme(this);
        this.planning = new services_1.Planning(this);
        this.population = new services_1.Population(this);
        this.route = new services_1.Route(this);
        this.staticMap = new services_1.StaticMap(this);
    }
}
exports.OneMap = OneMap;
OneMap.BASE_URL = 'https://developers.onemap.sg';
